module.exports = __webpack_public_path__ + "img/164.daa0a72b.jpg";